module.exports = __webpack_public_path__ + "assets/img/arrow_mobile.ebd0848d.svg";